<template>
    <div>
        <div class="lv_flex ls_aic ls_flex_wrap" style="margin-bottom: 15px">
            <div>用户创建时间：</div>
            <el-date-picker class="mr20 mb10" v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

            <div>用户更新时间：</div>
            <el-date-picker class="mr20 mb10" v-model="time2" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-input class="w300 mr20 mb10" v-model="params.nickName" placeholder="用户昵称（模糊）" />
            <el-input class="w300 mr20 mb10" v-model="params.phoneNumber" placeholder="手机号码（精确）" />
            <el-button type="primary" @click="params.pageIndex = 1; getList();">
                搜索
            </el-button>
        </div>
        <div style="margin: 20px 0">
            <h1 style="font-size: 40px">{{ total }}</h1>
            <div style="margin-top: 10px">总计用户数</div>
        </div>
        <el-table :data="list" style="width: 100%">
            <el-table-column prop="nickName" label="用户昵称"></el-table-column>
            <el-table-column prop="phoneNumber" label="手机号码"></el-table-column>
            <el-table-column prop="province" label="注册省份"></el-table-column>
            <el-table-column prop="city" label="注册城市"></el-table-column>
            <el-table-column prop="insertTime" label="创建时间"></el-table-column>
            <el-table-column prop="updateTime" label="更新时间"></el-table-column>
            <el-table-column label="机构" width="400">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.institutions" class="institution-card mb10 bgcf2 p4 br5" :key="index">
                        <div>机构ID：{{ item.institutionId }}</div>
                        <div>机构名称：{{ item.institutionName }}</div>
                        <div>机构版本：{{ {
                            1: '体验版',
                            2: '平台版',
                            3: '年费版',
                            4: '五年版本'
                        }[item.version] }}</div>
                    </div>

                </template>
            </el-table-column>
            <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                    <div
                        v-for="(item, index) in scope.row.institutions"
                        :key="index"
                        class="institution-operation mb10"
                    >
                        <template v-if="canOperateInstitution(item)">
                            <el-button type="text" @click="extendTime(item.institutionId)">
                                延长体验
                            </el-button>
                            <el-button type="text" @click="toFormal(item)">
                                转正
                            </el-button>
                        </template>
                        <span v-else class="color999">仅体验版支持操作</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            title="延长体验"
            :visible.sync="extendData.show"
            width="300px"
        >
            <el-date-picker
                v-model="extendData.expiration"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
            ></el-date-picker>
            <span slot="footer" class="dialog-footer">
                <el-button @click="extendData.show = false">取消</el-button>
                <el-button type="primary" @click="confirmTime">确定</el-button>
            </span>
        </el-dialog>

        <el-pagination background layout="prev, pager, next,sizes" :total="total" :page-sizes="[10, 50, 100, 200]"
            :current-page.sync="params.pageIndex" :page-size.sync="params.pageSize" @size-change="getList"
            @current-change="getList" style="margin-top: 15px"></el-pagination>

        <el-dialog title="转正" :visible.sync="formalData.show" width="500px">
            <el-form label-width="80px">
                <el-form-item label="学校logo">
                    <el-upload
                        accept=".png,.jpg,.jpeg"
                        :show-file-list="false"
                        action=""
                        :before-upload="
                            file => {
                                handleUpload(file);
                                return false;
                            }
                        "
                    >
                        <div v-if="formalData.logo">
                            <img
                                :src="formalData.logo | imgFormat"
                                class="review-img"
                                style="height: auto"
                            />
                            <i
                                class="el-icon-close"
                                @click="formalData.logo = ''"
                                @click.stop=""
                            ></i>
                        </div>
                        <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                            style="font-size: 30px"
                        ></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="学校名称">
                    <el-input v-model="formalData.name"></el-input>
                </el-form-item>
                <el-form-item label="成交金额">
                    <el-input v-model="formalData.cost"></el-input>
                </el-form-item>
                <el-form-item label="有效期">
                    <el-date-picker
                        v-model="formalData.expiration"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="签约版本">
                    <el-radio
                        v-model="formalData.versionId"
                        :label="item.id"
                        v-for="item in versionList"
                        :key="item.id"
                    >
                        {{ item.version }}
                    </el-radio>
                </el-form-item>
                <el-form-item>
                    <el-button @click="confirmFormal">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
export default {
    created () {
        this.getList();
        this.getVersionList();
    },
    data () {
        return {
            versionList: [],
            formalData: {
                id: "",
                expiration: "",
                show: false,
                name: "",
                versionId: "",
                cost: 0,
                logo: "",
            },
            extendData: {
                id: "",
                expiration: "",
                show: false,
            },
            list: [],
            total: 0,
            time: [],
            time2: [],
            params: {
                pageIndex: 1,
                pageSize: 10,
                nickName: "",
                phoneNumber: "",
                insertStartTime: "",
                insertEndTime: "",
                updateStartTime: "",
                updateEndTime: "",
            },
            ossUploadData: {},
        };
    },
    mounted () {
        this.getKey();
    },
    methods: {
        canOperateInstitution(item) {
            return item && String(item.version) === "1";
        },
        confirmFormal() {
            this.$ajax
                .post("/institution/official", this.formalData)
                .then(() => {
                    this.$message.success("保存成功");
                    this.formalData.show = false;
                    this.getList();
                });
        },
        toFormal(item) {
            this.formalData = {
                id: item.institutionId,
                expiration: "",
                show: true,
                name: item.institutionName || "",
                versionId: "",
                cost: 0,
                logo: "",
            };
        },
        confirmTime() {
            this.$ajax.post("/institution/renew", this.extendData).then(() => {
                this.$message.success("保存成功");
                this.extendData.show = false;
                this.getList();
            });
        },
        extendTime(id) {
            this.extendData = {
                id,
                expiration: "",
                show: true,
            };
        },
        sortUsersByInsertTime(list = []) {
            return [...list].sort((prev, next) => {
                const prevTime = new Date(
                    String(prev.insertTime || "").replace(/-/g, "/")
                ).getTime();
                const nextTime = new Date(
                    String(next.insertTime || "").replace(/-/g, "/")
                ).getTime();
                return (
                    (Number.isNaN(nextTime) ? 0 : nextTime) -
                    (Number.isNaN(prevTime) ? 0 : prevTime)
                );
            });
        },
        getList () {
            if (this.time.length) {
                this.params.insertStartTime = this.time[0];
                this.params.insertEndTime = this.time[1];
            } else {
                this.params.insertStartTime = "";
                this.params.insertEndTime = "";
            }


            if (this.time2.length) {
                this.params.updateStartTime = this.time2[0];
                this.params.updateEndTime = this.time2[1];
            } else {
                this.params.updateStartTime = "";
                this.params.updateEndTime = "";
            }

            this.$ajax
                .post("/admin/user/pageList", this.params)
                .then(res => {
                    this.list = this.sortUsersByInsertTime(res.list || []);
                    this.total = res.total;
                });
        },
        getVersionList() {
            this.$ajax
                .post("/basic/version/getPage", {
                    pageNum: 1,
                    pageSize: 100,
                })
                .then(res => {
                    this.versionList = res.list;
                });
        },
        getKey() {
            this.$ajax
                .post("/user/oss/getKey?pathName=cover")
                .then(res => {
                    this.ossUploadData.cover = res.data;
                });
        },
        handleUpload(file) {
            this.getUploadPromise(
                {
                    file,
                },
                this.ossUploadData.cover
            ).then(res => {
                this.$set(this.formalData, "logo", res.addr);
            });
        },

    },
};
</script>

<style scoped>
.institution-card {
    min-height: 88px;
}

.institution-operation {
    min-height: 88px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.review-img {
    width: 100px;
}
</style>
